<template>
  <p class="text-xs text-gray-500 dark:text-gray-400 text-center">
    {{ t("pages.fitrana.disclaimer") }}
  </p>
</template>

<script setup lang="ts">
const { t } = useI18n();
</script>
